export enum enumPalletStandard {
  GMA = 0,
  EUR_1 = 1,
  EUR_2 = 2,
  OTHER = null,
}
